module.exports = __webpack_public_path__ + "static/media/add-circle-filled.085dcbb7.svg";